module.exports = __webpack_public_path__ + "img/stray-menu-1.28ad433d.jpg";